import React, { Component } from "react";
import "../style/loginStyle.css";
import logo from "../img/sadat logo-png.png";
import {AiOutlineEye, AiOutlineEyeInvisible, AiOutlineLock, AiOutlineUser, AiOutlineWarning} from "react-icons/ai";
import {Link} from "react-router-dom";
import axios from "axios";
import {Box, Button, CircularProgress} from "@mui/material";
import { API_BASE_URL } from '../api/client';

const REMEMBER_KEY = 'saadat_remember_user';

class Login extends Component {
  state = {
    showPassword: false,
    rememberMe: Boolean(localStorage.getItem(REMEMBER_KEY)),
    response: '',
    loading: false,
    account: {
      user: localStorage.getItem(REMEMBER_KEY) || '',
      password: ''
    },
    validation: {
      userRequiredReg: '',
      passwordRequiredReg: '',
    },
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (e) => {
    if (e.key === 'Enter' && !this.state.loading) {
      this.handleSubmit();
    }
  };

  render() {
    const {user, password} = this.state.account
    const showAuthError = this.state.validation.userRequiredReg === true &&
        this.state.validation.passwordRequiredReg === true && this.state.response !== '';

    return (
        <div className="container-login">
          <div className="login-bg" aria-hidden="true">
            <div className="login-bg-photo"/>
            <div className="login-bg-shade"/>
          </div>
          <div className="login-shell">
            <div className="login-brand">
              <img className="brand-mark" src={logo} alt="لوگوی سعادت پرتال"/>
              <h1>سعادت پرتال</h1>
              <p>سامانه مدیریت خوابگاه برای پذیرش، ظرفیت و عملیات روزانه.</p>
            </div>

            <div className="login-panel">
              <div className="login-form" role="form" aria-label="فرم ورود">
                <div className="title-form">
                  <h3>ورود به پنل</h3>
                </div>
                <p className="form-hint">اطلاعات حساب سازمانی خود را وارد کنید</p>

                {showAuthError ? (
                    <div className="login-alert" role="alert">
                      <AiOutlineWarning size={18}/>
                      <span>نام کاربری یا رمز عبور صحیح نیست. دوباره تلاش کنید یا از فراموشی رمز استفاده کنید.</span>
                    </div>
                ) : null}

                <div className="form-group">
                  <label className="field-label" htmlFor="login-user">نام کاربری</label>
                  <div className="field-wrap">
                    <span className="field-icon"><AiOutlineUser size={18}/></span>
                    <input
                        id="login-user"
                        type="text"
                        name="user"
                        value={user}
                        onChange={this.handleChange}
                        className={`form-control input${this.state.validation.userRequiredReg === false ? ' is-invalid' : ''}`}
                        placeholder="مثلاً supervisor01"
                        autoComplete="username"
                        autoFocus
                    />
                  </div>
                  {this.state.validation.userRequiredReg === false ? (
                      <span className="field-error">نام کاربری الزامی است</span>
                  ) : null}
                </div>

                <div className="form-group">
                  <label className="field-label" htmlFor="login-password">گذرواژه</label>
                  <div className="field-wrap">
                    <span className="field-icon"><AiOutlineLock size={18}/></span>
                    <input
                        id="login-password"
                        type={this.state.showPassword ? "text" : "password"}
                        name="password"
                        value={password}
                        onChange={this.handleChange}
                        className={`form-control input password${this.state.validation.passwordRequiredReg === false ? ' is-invalid' : ''}`}
                        placeholder="••••••••"
                        autoComplete="current-password"
                    />
                    <button
                        type="button"
                        className="password-toggle"
                        aria-label={this.state.showPassword ? "مخفی کردن گذرواژه" : "نمایش گذرواژه"}
                        onClick={() => this.setState({showPassword: !this.state.showPassword})}
                    >
                      {this.state.showPassword ? <AiOutlineEyeInvisible size={18}/> : <AiOutlineEye size={18}/>}
                    </button>
                  </div>
                  {this.state.validation.passwordRequiredReg === false ? (
                      <span className="field-error">گذرواژه الزامی است</span>
                  ) : null}
                </div>

                <div className="option-row">
                  <div className="remember">
                    <input
                        type="checkbox"
                        id="chk-remember"
                        className="chk-remember"
                        checked={this.state.rememberMe}
                        onChange={(e) => this.setState({rememberMe: e.target.checked})}
                    />
                    <label htmlFor="chk-remember">مرا به خاطر بسپار</label>
                  </div>
                  <Link to="/forgot-password" className="forgot">فراموشی رمز؟</Link>
                </div>

                <Box className="w-100" sx={{position: 'relative'}}>
                  <Button
                      variant="contained"
                      className="btn-login w-100"
                      disabled={this.state.loading}
                      onClick={this.handleSubmit}
                  >
                    {this.state.loading ? 'در حال ورود…' : 'ورود به سامانه'}
                  </Button>
                  {this.state.loading && (
                      <CircularProgress
                          size={22}
                          sx={{
                            color: "#16120e",
                            position: 'absolute',
                            top: '50%',
                            left: '1.1rem',
                            marginTop: '-11px',
                          }}
                      />
                  )}
                </Box>
                <div className="login-footer">با ورود، دسترسی بر اساس نقش شما فعال می‌شود</div>
              </div>
            </div>
          </div>
        </div>
    );
  }

  handleChange = ({currentTarget: input}) => {
    const account = {...this.state.account};
    account[input.name] = input.value;
    this.setState({account, response: ''})
  }

  validation = () => {
    let requiredReg = /^\s*$/;
    let user_Reg = !requiredReg.test(this.state.account.user);
    let pass_reg = this.state.account.password !== '';

    let updateValidation = {...this.state.validation};
    updateValidation.userRequiredReg = user_Reg;
    updateValidation.passwordRequiredReg = pass_reg;
    this.setState({validation: updateValidation})
    return user_Reg && pass_reg;
  }

  handleSubmit = async () => {
    if (this.state.loading) return;
    this.setState({loading: true, response: ''})
    const res = this.validation();

    if (!res) {
      this.setState({loading: false});
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/login`, null, {
        params: {
          username: this.state.account.user,
          password: this.state.account.password
        },
        headers: {
          "content-type": "application/x-www-form-urlencoded",
        }
      });
      localStorage.setItem("accessToken", response.headers["accesstoken"]);
      localStorage.setItem("refreshToken", response.headers["refreshtoken"]);
      localStorage.setItem("role", response.headers["role"]);
      localStorage.setItem("username", this.state.account.user);
      localStorage.setItem("id", response.headers["id"]);
      if (this.state.rememberMe) {
        localStorage.setItem(REMEMBER_KEY, this.state.account.user);
      } else {
        localStorage.removeItem(REMEMBER_KEY);
      }
      const role = response.headers["role"];
      window.location = role === "MANAGER" ? "/dashboard/People" : "/dashboard/Register";
    } catch (err) {
      this.setState({response: err, loading: false});
    }
  }
}
export default Login;
